module.exports = __webpack_public_path__ + "g+.svg";